import * as Sentry from "@sentry/browser";
import React, { Component } from "react";

type IProps = {
  FallbackComponent?: React.ReactNode;
  onError: () => void;
  children: React.ReactNode;
};

type IState = { hasError: boolean };

export class ErrorBoundary extends Component<IProps, IState> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static defaultProps = {
    FallbackComponent: null,
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidCatch(error: Error) {
    // You can also log the error to an error reporting service
    this.setState({ hasError: true });
    Sentry.captureException(error);
  }

  componentDidUpdate(): void {
    if (this.state.hasError) {
      this.props.onError();
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.FallbackComponent ? this.props.FallbackComponent : null;
    }

    return this.props.children;
  }
}
